import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { Call } from '../../../calls.service'
import { ProgressLoaderComponent } from '../../../common/progress-loader/progress-loader.component'

/** The loader shown in place of the minutes while a run generates them. */
@Component({
  selector: 'app-minutes-generation-progress',
  standalone: true,
  imports: [ProgressLoaderComponent, TranslatePipe],
  templateUrl: './minutes-generation-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './minutes-generation-progress.component.scss',
})
export class MinutesGenerationProgressComponent {
  @Input({ required: true }) call!: Call
}
